"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const context_1 = require("src/context/context");
const SingleBranch_1 = tslib_1.__importDefault(require("src/modules/references/structuralUnitsUpgraded/views/SingleBranch"));
const defaultDragProperties = {
    draggingId: null,
    hoveredId: null
};
const Branches = (props) => {
    const { structuralUnits, hook, openParent, closeParent, setAttachUser, setUnitAndParentId, setAuthority, setAuthorityId, setEditFormData, parentId, parentName, prefixForPosition, handleOpenHierarchy, fetchingHierarchy, setValue, noPositionsAllowed, noStructuralUnitsAllowed, restrictOccupiedPosition } = props;
    const [sortingUnits, setSortingUnits] = (0, react_1.useState)(null);
    const [dragProperties, setDragProperties] = (0, react_1.useState)(defaultDragProperties);
    const { toast } = (0, context_1.useToastContext)();
    const getClassNamesForTree = (unit) => {
        return [
            'jstree-node btn-hover-primary',
            !unit.hasChildren && 'jstree-leaf',
            unit.isOpen && unit.children?.length > 0 ? 'jstree-open' : 'jstree-closed',
            unit.isLastNode && 'jstree-last',
            hook.state.loadingItems.includes(unit.identifier) && 'jstree-loading',
            dragProperties.draggingId === unit.id && 'drag-active',
            dragProperties.hoveredId === unit.id && dragProperties.draggingId !== dragProperties.hoveredId && 'drag-overed'
        ].filter(Boolean).join(' ');
    };
    const handleDragStart = (draggingId) => {
        setSortingUnits(structuralUnits);
        setDragProperties(prevState => {
            return { ...prevState, draggingId };
        });
    };
    const handleDragOver = (hoveredId, hoveredIdentifier) => {
        if (sortingUnits?.some(el => el.identifier === hoveredIdentifier)) {
            setDragProperties(prevState => {
                return { ...prevState, hoveredId };
            });
        }
    };
    const handleDragEnd = async (parentId) => {
        const { draggingId, hoveredId } = dragProperties;
        if (draggingId && hoveredId && (draggingId !== hoveredId)) {
            const newUnits = [...structuralUnits];
            const draggedIndex = newUnits.findIndex((unit) => unit.id === draggingId);
            const hoveredIndex = newUnits.findIndex((unit) => unit.id === hoveredId);
            const [draggedItem] = newUnits.splice(draggedIndex, 1);
            newUnits.splice(hoveredIndex, 0, draggedItem);
            const res = await hook.sortStructuralUnits(newUnits);
            if (res.errors === null) {
                toast.successMessage(res.status);
                hook.reFetchParent(draggingId, parentId).then();
            }
            else {
                res.errors.map((el) => toast.danger(el.message));
            }
        }
        setDragProperties(defaultDragProperties);
        setSortingUnits(null);
    };
    return ((0, jsx_runtime_1.jsx)("ul", { className: 'jstree-children', children: structuralUnits.map((unit) => ((0, jsx_runtime_1.jsxs)("li", { className: getClassNamesForTree(unit), children: [(0, jsx_runtime_1.jsx)(SingleBranch_1.default, { structuralUnit: unit, openParent: openParent, reFetchParent: hook.reFetchParent, setUnitAndParentId: setUnitAndParentId, closeParent: closeParent, deleteUnit: hook.deleteUnit, isDeleting: hook.state.isDeleting, isLoading: hook.state.loadingItems.includes(unit.identifier), setAttachUser: setAttachUser, setAuthority: setAuthority, setAuthorityId: setAuthorityId, setEditFormData: setEditFormData, parentId: parentId, handleDragStart: handleDragStart, handleDragOver: handleDragOver, handleDragEnd: handleDragEnd, parentName: parentName, prefixForPosition: prefixForPosition, handleOpenHierarchy: handleOpenHierarchy, fetchingHierarchy: fetchingHierarchy, setValue: setValue, restrictOccupiedPosition: restrictOccupiedPosition, noPositionsAllowed: noPositionsAllowed, noStructuralUnitsAllowed: noStructuralUnitsAllowed }), unit.children.length > 0 && ((0, jsx_runtime_1.jsx)("ul", { children: unit.children && unit.isOpen
                        ? (0, jsx_runtime_1.jsx)(Branches, { structuralUnits: unit.children, hook: hook, openParent: openParent, closeParent: closeParent, setAttachUser: setAttachUser, setAuthority: setAuthority, setUnitAndParentId: setUnitAndParentId, setEditFormData: setEditFormData, parentId: unit.id, setAuthorityId: setAuthorityId, parentName: unit.name, prefixForPosition: unit.prefixForPosition, handleOpenHierarchy: handleOpenHierarchy, fetchingHierarchy: fetchingHierarchy, setValue: setValue, restrictOccupiedPosition: restrictOccupiedPosition, noPositionsAllowed: noPositionsAllowed, noStructuralUnitsAllowed: noStructuralUnitsAllowed }, unit.id)
                        : null }))] }, unit.id))) }));
};
exports.default = Branches;
